export const regExpInternalPromo = /2GTHR-[A-Z0-9]{5}-[A-Z0-9]{5}-[A-Z0-9]{5}$/;
